/* global videojs */
import vars from '../helpers';

const init = () => {
	const $videos = $('.js-video');

	$videos.each((i, el) => {
		console.log('video init');
		const $video = $(el);
		const poster = $video.attr('poster');
		const name = $video.data('name');
		const src = $video.attr('src');

		const video = videojs($video[0], {
			controls: true,
			autoplay: false,
			muted: false,
			loop: false,
			playsinline: true,
			preload: 'auto',
			responsive: true,
			poster,
			html5: {
				nativeAudioTracks: false,
				nativeVideoTracks: false,
				nativeTextTracks: false,
				vhs: {
					overrideNative: true,
				},
			},
		});

		video.src({
			src,
			type: 'application/x-mpegURL',
			withCredentials: false,
		});

		let wrapper =  $($video).parent();
		let wrapperVideo = $video.closest('.js-video-wrapper');
		const $buttonPlay = $video.closest('.js-video-wrapper').find('.js-video-play');

		// $buttonPlay.on('click', function(e) {
		// 	console.log('was click event');
		// 	stopVideo();
		//
		// 	if( !$(wrapperVideo).hasClass('is-started') ) {
		// 		$(wrapperVideo).addClass('is-started');
		// 		video.play();
		// 	}
		// });

		let videoInterval = false;

		$video.on('play', (el) => {
			// if( $(wrapperVideo).hasClass('popupVideo') ) {
			// 	document.querySelector('.js-cybersecurity-video video').pause();
			// }
			//
			//
			// if( $(wrapperVideo).hasClass('is-pause') ) {
			// 	$(wrapperVideo).removeClass('is-pause');
			// 	$(wrapperVideo).addClass('is-play');
			// }

			vars.$html.trigger('video-play', name);

			videoInterval = setInterval(() => {
				vars.$html.trigger('video-interval-30', name);
			}, 30000);
		});

		$video.on('ended', () => {
			vars.$html.trigger('video-ended', name);
			clearInterval(videoInterval);
		});

		$video.on('pause', () => {
			// if( $(wrapperVideo).hasClass('is-started') ) {
			// 	if( !$(wrapperVideo).hasClass('is-pause') ) {
			// 		$(wrapperVideo).removeClass('is-play');
			// 		$(wrapperVideo).addClass('is-pause');
			// 	}
			// }

			// if( $('.js-video-wrapper').hasClass('is-started') ) {
			// 	$('.js-video-wrapper').addClass('is-pause');
			// 	$('.js-video-wrapper').removeClass('is-play');
			// }

			// if( $('.js-video-wrapper.popupVideo').hasClass('is-started') ) {
			// 	$('.js-video-wrapper.is-started').addClass('is-pause');
			// 	$('.js-video-wrapper.is-started').removeClass('is-play');
			// }

			console.log('pause');

			clearInterval(videoInterval);
		});
	});

	function clickVideo() {
		$('.js-video-play').on('click', function (e) {
			console.log('was click event');
			let wrapperVideo = $(this).closest('.js-video-wrapper');
			let video = $(wrapperVideo).find('video');
			stopVideo();

			// $(e.currentTarget).addClass('is-hidden');

			if( $(wrapperVideo).hasClass('popupVideo') ) {
				document.querySelector('.js-cybersecurity-video video').pause();
			}

			if( !$(wrapperVideo).hasClass('is-started') ) {
				$(wrapperVideo).addClass('is-started');
				$(wrapperVideo).removeClass('is-pause');
				$(wrapperVideo).addClass('is-play');

				$(video).trigger('play');
				console.log('play start');
			} else {

				if( $(wrapperVideo).hasClass('is-pause') ) {
					$(wrapperVideo).addClass('is-play');
					$(wrapperVideo).removeClass('is-pause');

					$(video).trigger('play');
					console.log('play');

				} else if ( $(wrapperVideo).hasClass('is-play') ) {
					$(wrapperVideo).addClass('is-pause');
					$(wrapperVideo).removeClass('is-play');

					$(video).trigger('pause');
					console.log('pause');
				}
			}
		});
	}

	function stopVideo() {
		let videos = document.querySelectorAll('video')

		videos.forEach(function (el) {
			el.pause();
		})
	}

	clickVideo();
};

export default {
	init,
};
